import { useLayoutEffect, useState } from "react";
import { useMedia } from "react-use";

/**
 * Breakpoints matching tailwind.config.js screens.
 * Hardcoded to avoid runtime dependency on tailwindcss/resolveConfig
 * (removed in Tailwind v4).
 */
export const xs = "375px";
export const sm = "416px";
export const md = "624px";
export const lg = "1056px";
export const xl = "1440px";

export function useMediaMinWidth(minWidth: string, defaultState?: boolean) {
  return useMedia(`(min-width: ${minWidth})`, defaultState);
}

/**
 * Breakpoint-dependent markup that must hydrate cleanly.
 *
 * Unlike `useMediaMinWidth`, the first render always reports `true` (the
 * desktop layout the server rendered) and the real match is applied in a
 * layout effect, before the browser paints. Use it when the rendered copy or
 * structure differs by breakpoint (hero headlines), so SSR and the first client
 * render agree and the swap is invisible.
 */
export function useMediaMinWidthBeforePaint(minWidth: string): boolean {
  const [matches, setMatches] = useState(true);

  useLayoutEffect(() => {
    const media = window.matchMedia(`(min-width: ${minWidth})`);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [minWidth]);

  return matches;
}
